import styled from 'styled-components'
import { TextField, Tooltip } from '@mui/material'

interface Props {
  register?: (instance: any) => void
  inputRef?: React.MutableRefObject<HTMLInputElement | undefined>
  name: string
  label?: string
  required?: boolean
  min?: string
  max?: string
  dateOnly?: boolean
  fullWidth?: boolean
  disabled?: boolean
  className?: string
  tooltipContent?: JSX.Element | string
  initialValue?: string
  showSeconds?: boolean
  style?: React.CSSProperties
}

export default function DateTimePicker({
  register,
  inputRef,
  name,
  label,
  required = false,
  min = '',
  max = '',
  dateOnly = false,
  fullWidth = false,
  disabled = false,
  className,
  tooltipContent,
  initialValue,
  showSeconds = false,
  style = {},
}: Props): JSX.Element {
  const labelText = dateOnly ? label : `${label}`
  const pickerType = dateOnly ? 'date' : 'datetime-local'

  const getLabelText = () => {
    if (!labelText) {
      return ''
    }
    return tooltipContent ? (
      <>
        {labelText} {renderTooltip()}
      </>
    ) : (
      labelText
    )
  }

  const renderTooltip = () => {
    return (
      <Tooltip title={<TooltipContent>{tooltipContent}</TooltipContent>} placement="right">
        <InfoButton>i</InfoButton>
      </Tooltip>
    )
  }

  const getStep = () => {
    return showSeconds || dateOnly ? 1 : 60
  }

  return (
    <StyledPicker
      name={name}
      inputRef={inputRef}
      label={getLabelText()}
      type={pickerType}
      required={required}
      inputProps={{ min, max, step: getStep() }}
      fullWidth={fullWidth}
      disabled={disabled}
      className={className}
      defaultValue={initialValue}
      {...(register ? register(name) : {})}
      style={style}
      // sx={{
      //   '& .MuiOutlinedInput-root': {
      //     backgroundColor: '#fff',
      //     borderRadius: '8px',
      //     boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',

      //     '& fieldset': {
      //       borderColor: '#e4e4e7',
      //     },

      //     '&:hover fieldset': {
      //       borderColor: '#e4e4e7',
      //     },

      //     '&.Mui-focused fieldset': {
      //       borderColor: '#e4e4e7',
      //     },
      //   },

      //   '& .MuiOutlinedInput-input': {
      //     padding: '10px 12px',
      //   },
      // }}
    />
  )
}

const StyledPicker = styled(TextField)`
  margin-top: 15px;

  & div:before,
  .MuiInput-underline:hover:before {
    border-bottom: none;
  }

  & .MuiInput-underline:hover {
    & input {
      border-color: #1aa85d;
    }
  }

  & input {
    border: 1px solid;
    border-color: ${(props) => props.theme.customPalette.mediumGray};
    border-radius: 5px;
    padding: 16px 14px;
  }
  & label {
    transition: none;
    transform: none;
    margin-top: -20px;
  }
`

const InfoButton = styled.div`
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  text-align: center;
  font-size: 12px;
  line-height: 12px;
  padding: 2px;
  background-color: ${(props) => props.theme.palette.primary.main};
  color: ${(props) => props.theme.customPalette.light};
`

const TooltipContent = styled.div`
  padding: 10px;
  font-size: 12px;
  & div {
    margin: 5px 0;
  }
`
